import React, {useEffect, useState, useRef} from "react";
import {confirmAlert} from "react-confirm-alert";
import {
  getAxiosResponse,
  deleteAxiosResponse,
  putAxiosResponse,
  postAxiosResponse,
} from "../../../../services/authApiRoutes/APImethods";
import $ from "jquery";
import Select from "react-select";
import APIUrls from "../../../../services/APIUrls";
import {transformBlankToNull} from "../../../../services/Util";
import Constants from "../../../../Constants";
import { handleError } from "../../../../services/authApiRoutes/APImethods";


export default function ErrorType() {
  const [success, setSuccess] = useState(false);
  const [formDisabled, setFormDisabled] = useState(true);
  const [errorType, setErrorType] = useState([]);
  const [errorCategories, setErrorCategories] = useState([]);
  const [errorTypeToUdate, setErrorTypeToUpdate] = useState({});
  const [newErrorTypeName, setNewErrorTypeName] = useState("");
  const [newErrorTypeDescription, setNewErrorTypeDescription] = useState("");
  const [newErrorTypeId, setNewErrorTypeId] = useState("");
  const [selectedErrorCategory, setSelectedErrorCategory] = useState({});
  const inputRef = useRef(null);
  const currentDeleteIdRef = useRef(null);
  const [securityData,setSecurityData]=useState({})
  const [errorTypeStatus,setErrorTypeStatus]=useState(true)

  const enableDisableErrorType = (e, id) => {
    var newState = errorType.map((obj) => {
      if (obj.id === id) {
        return {...obj, isEnabled: e.target.checked};
      }
      return obj;
    });
    setErrorType(newState);
    var selectedLevel = errorType.filter((type) => {
      return type.id === id;
    });
    selectedLevel[0]["isEnabled"] = e.target.checked;
    var payload = transformBlankToNull(selectedLevel[0]);
    putAxiosResponse(APIUrls.CUSTOMER_FEEDBACK_ERROR_TYPE, payload).then(res=>{
      let data=res?.data?.data?.body?.data
      if(data){
       setSecurityData(data)
       setSelectedErrorCategory(data?.errorCategory)
       setFormDisabled(data && data?.isSystem);
      }
     }).catch(err=>{
       console.error(err)
     });
  };
  const clearFields = () => {
    setErrorTypeToUpdate({});
    setNewErrorTypeId("");
    setNewErrorTypeDescription("");
    setNewErrorTypeName("");
    setFormDisabled(true);
        $('.new-form-btn-errorType').trigger('focus')
          $('.edit-focus').trigger('focus')
    $('.edit-icon').removeClass('edit-focus')
  };
  const newForm = () => {
    setFormDisabled(false);
    setSelectedErrorCategory({});
    setErrorTypeToUpdate({});
    setNewErrorTypeName("");
    setNewErrorTypeDescription("");
    setSecurityData("")
    setNewErrorTypeId("");
    window.scrollTo(0, 0);
  };

  useEffect(()=>{
    if(securityData){
      setNewErrorTypeId(securityData?.errorTypeId);
      setNewErrorTypeName(securityData?.name);
      setNewErrorTypeDescription(securityData?.description);
    }
  },[securityData])


 $(document).on("click",".new-form-btn-errorType",function() {
    if( !$(".focus-input").is(':disabled') ) {
      // inputRef.current.focus();
      $('.cw__input').trigger('focus')
    }
  });

  $(document).on("click",".edit-icon",function() {
    $(this).addClass('edit-focus')
    });

  const createUpdateErrorType = () => {
    if (errorTypeToUdate.id === undefined) {
      var payload = {
        errorCategory: selectedErrorCategory,
        name: newErrorTypeName,
        errorTypeId: newErrorTypeId,
        description: newErrorTypeDescription,
      };
      var nulledPayload = transformBlankToNull(payload);
      postAxiosResponse(
        APIUrls.CUSTOMER_FEEDBACK_ERROR_TYPE,
        nulledPayload
      ).then((res) => {
        clearFields();
        getData();
      });
    } else {
      errorTypeToUdate.name =
        newErrorTypeName !== "" ? newErrorTypeName : errorTypeToUdate.name;
      errorTypeToUdate.description =
        newErrorTypeDescription !== ""
          ? newErrorTypeDescription
          : errorTypeToUdate.description;
      errorTypeToUdate.errorTypeId =
        newErrorTypeId !== "" ? newErrorTypeId : errorTypeToUdate.severityId;
      errorTypeToUdate.errorCategory =
        selectedErrorCategory !== ""
          ? selectedErrorCategory
          : errorTypeToUdate.errorCategory;
      let payload = transformBlankToNull(errorTypeToUdate);
      putAxiosResponse(APIUrls.CUSTOMER_FEEDBACK_ERROR_TYPE, payload).then(
        (res) => {
          clearFields();
          getData();
        }
      );
    }
  };
  const confirmDelete = (row, e) => {
     currentDeleteIdRef.current = e.currentTarget.id;
    setTimeout(() => {
      $("#deleteNo").trigger("focus");
      $("#react-confirm-alert").attr( { role:"dialog", 'aria-modal':"true", 'aria-label':"Confirm Delete Error Type" } );
    }, 500);
    confirmAlert({
      title: "Confirm Delete Error Type",
      message: <p>Delete Error Type: {row.name}</p>,
      buttons: [
        {
          label: "No",
          id: "deleteNo",
          onClick: () => {
          $("#" + currentDeleteIdRef.current).trigger("focus");
        },
          onKeyDown: (e) => {
            if (e.key === Constants.TAB) {
              // if (e.shiftKey === false) {
                e.preventDefault();
                $("#deleteYes").trigger("focus");
              // }
            }
            if (e.key === Constants.ESCAPE) {
              if (e.shiftKey === false) {
                e.preventDefault();
                $("#" + currentDeleteIdRef.current).trigger("focus");
              }
            }
          },
        },
        {
          label: "Yes",
          id: "deleteYes",
          onClick: () =>
            deleteAxiosResponse(
              APIUrls.DELETE_CUSTOMER_FEEDBACK_ERROR_TYPE(row.id)
            )
              .then((res) => {
                success ? setSuccess(false) : setSuccess(true);
                $(".lastdisable").trigger("focus");
                getData();
              })
              .catch((err) => {
                handleError(err);
              }),
          onKeyDown: (e) => {
            if (e.key === Constants.TAB) {
              // if (e.shiftKey === true) {
                e.preventDefault();
                $("#deleteNo").trigger("focus");
              // }
            }
              if (e.key === Constants.ESCAPE) {
              if (e.shiftKey === false) {
                e.preventDefault();
                $("#" + currentDeleteIdRef.current).trigger("focus");
              }
            }
          },
        },
       
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
    });
  };
  const getErrorCategories = () => {
    var categories = [];
    getAxiosResponse(APIUrls.CUSTOMER_FEEDBACK_ERROR_CATEGORY)
      .then((res) => {
        if (res.data !== "") {
          res.data.data.body.data.map((category) => {
            categories.push({
              label: category.name,
              value: category,
            });
          });
          setErrorCategories(categories);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };
  const updateType = (type) => {
    window.scrollTo(0, 0);
    // inputRef.current.focus();
    setErrorTypeToUpdate(type);
    setFormDisabled(false);
    setSelectedErrorCategory(type.errorCategory);
    setNewErrorTypeName(type.name);
    setNewErrorTypeDescription(type.description);
    setNewErrorTypeId(type.errorTypeId);
  };
  const getData = () => {
    getAxiosResponse(APIUrls.CUSTOMER_FEEDBACK_ERROR_TYPE)
      .then((res) => {
        if (res.data !== "") {
          let finalData=res?.data?.data?.body?.data
          if(finalData && finalData?.length > 0 ){
            setErrorType(finalData);
            if(errorTypeStatus){
              setSelectedErrorCategory(finalData[0]?.errorCategory);
              setNewErrorTypeName(finalData[0]?.name);
              setNewErrorTypeDescription(finalData[0]?.description);
              setNewErrorTypeId(finalData[0]?.errorTypeId);
            }
          }
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };
  const notEditable = (type) => {
    window.scrollTo(0, 0);
    inputRef.current?.focus();
    setErrorTypeToUpdate(type);
    setFormDisabled(true);
    setSelectedErrorCategory(type.errorCategory);
    setNewErrorTypeName(type.name);
    setNewErrorTypeDescription(type.description);
    setNewErrorTypeId(type.errorTypeId);
  };
  const handleErrorCategoryChange = (event) => {
    setSelectedErrorCategory(event.value);
  };

  useEffect(() => {
    getErrorCategories();
    getData();
  }, []);
  return (
    <div className="flex inner-errortopology">
      <div className="left-topology">
        <div className="inner-left-topology">
          <h6>Error Types </h6>
          {errorType.map((type, index) => {
            if (type.deleted) {
              return "";
            } else {
              return (
                <div key={index} className="flex justify-center">
                  <div className="form-check small-checkbox fix-width-150">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name={type.labelCode}
                      id={type.id}
                      checked={type.isEnabled}
                      onChange={(e) => enableDisableErrorType(e, type.id)}
                    />
                    <label className="form-check-label" htmlFor={type.id}>
                      {type.name}
                    </label>
                  </div>
                  {!type.isSystem ? (
                    <div className="file-actions">
                      <button
                        className="mr-15 inline-flex"
                        aria-label={`${(type.name)}delete`}
                        onClick={(e) => confirmDelete(type, e)}
                         id={"delete-icon-" + JSON.stringify(index)}
                      >
                        <svg
                          className="aaa-change-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M11.0599 2.33973C11.3056 2.58546 11.4573 2.90766 11.4917 3.25039H8.50673C8.54117 2.90766 8.69283 2.58546 8.93856 2.33973C9.21986 2.05843 9.60139 1.90039 9.99922 1.90039C10.397 1.90039 10.7786 2.05843 11.0599 2.33973ZM7.94861 1.34978C7.44021 1.85818 7.14008 2.5359 7.1031 3.25039H1.74922C1.56357 3.25039 1.38552 3.32414 1.25424 3.45542C1.12297 3.58669 1.04922 3.76474 1.04922 3.95039C1.04922 4.13604 1.12297 4.31409 1.25424 4.44537C1.38552 4.57664 1.56357 4.65039 1.74922 4.65039H2.77494L4.07301 15.896C4.17007 16.7369 4.57287 17.5127 5.20477 18.0759C5.83666 18.6391 6.65356 18.9503 7.50001 18.9504H12.4984C13.3449 18.9503 14.1618 18.6391 14.7937 18.0759C15.4256 17.5127 15.8284 16.7369 15.9254 15.896L17.2235 4.65039H18.2492C18.4349 4.65039 18.6129 4.57664 18.7442 4.44537C18.8755 4.31409 18.9492 4.13604 18.9492 3.95039C18.9492 3.76474 18.8755 3.58669 18.7442 3.45542C18.6129 3.32414 18.4349 3.25039 18.2492 3.25039H12.8953C12.8584 2.5359 12.5582 1.85818 12.0498 1.34978C11.506 0.805925 10.7683 0.500391 9.99922 0.500391C9.23009 0.500391 8.49246 0.805925 7.94861 1.34978ZM6.13615 17.0311C5.76064 16.6966 5.52118 16.2358 5.46333 15.7362C5.46333 15.7362 5.46333 15.7362 5.46332 15.7361L4.18462 4.65039H15.8138L14.5351 15.7361C14.4773 16.2357 14.2378 16.6966 13.8623 17.0311C13.4868 17.3657 13.0014 17.5505 12.4984 17.5504H7.50002C6.99708 17.5505 6.51168 17.3657 6.13615 17.0311ZM8.84419 7.30542C8.71292 7.17414 8.53487 7.10039 8.34922 7.10039C8.16357 7.10039 7.98552 7.17414 7.85424 7.30542C7.72297 7.43669 7.64922 7.61474 7.64922 7.80039V14.4004C7.64922 14.586 7.72297 14.7641 7.85424 14.8954C7.98552 15.0266 8.16357 15.1004 8.34922 15.1004C8.53487 15.1004 8.71292 15.0266 8.84419 14.8954C8.97547 14.7641 9.04922 14.586 9.04922 14.4004V7.80039C9.04922 7.61474 8.97547 7.43669 8.84419 7.30542ZM12.3492 7.80039C12.3492 7.61474 12.2755 7.43669 12.1442 7.30542C12.0129 7.17414 11.8349 7.10039 11.6492 7.10039C11.4636 7.10039 11.2855 7.17414 11.1542 7.30542C11.023 7.43669 10.9492 7.61474 10.9492 7.80039V14.4004C10.9492 14.586 11.023 14.7641 11.1542 14.8954C11.2855 15.0266 11.4636 15.1004 11.6492 15.1004C11.8349 15.1004 12.0129 15.0266 12.1442 14.8954C12.2755 14.7641 12.3492 14.586 12.3492 14.4004V7.80039Z"
                            fill="#1D4ED8"
                            stroke="#1D4ED8"
                            strokeWidth="0.3"
                          />
                        </svg>
                      </button>
                      <button
                        className="edit-icon new-form-btn-errorType"
                        aria-label={`${(type.name)} edit`}
                        onClick={() => updateType(type)}
                      >
                        <svg
                          className="aaa-change-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                        >
                          <path
                            d="M4.65122 14.1491H0.817969V10.3143L10.5199 0.642481L10.52 0.642316C10.8375 0.324878 11.2595 0.15 11.7092 0.15C12.1589 0.15 12.5809 0.324838 12.8993 0.643233L14.3532 2.09707C14.6715 2.41546 14.8464 2.83748 14.8464 3.28717C14.8464 3.73685 14.6715 4.15887 14.3532 4.47727L4.65122 14.1491ZM11.8152 1.7272L11.7093 1.62143L11.6033 1.7271L10.1467 3.1791L10.0403 3.2852L10.1466 3.39143L11.6004 4.84435L11.7063 4.95015L11.8123 4.84452L13.2698 3.39252L13.3764 3.28638L13.27 3.18012L11.8152 1.7272ZM2.3513 12.4657V12.6157H2.5013H3.95605H4.01805L4.06195 12.572L10.5144 6.13973L10.6208 6.03367L10.5145 5.92743L9.0607 4.4736L8.9548 4.3677L8.84873 4.47343L2.3954 10.9066L2.3513 10.9506V11.0128V12.4657ZM0.817969 16.2824H15.1846V17.8157H0.817969V16.2824Z"
                            fill="#1D4ED8"
                            stroke="#F1F5FF"
                            strokeWidth="0.3"
                          />
                        </svg>
                      </button>
                    </div>
                  ) : (
                    <div className="file-actions">
                      <button
                        className="mr-15 inline-flex"
                        aria-label={`${(type.name)} delete`}
                        tabIndex="-1"
                        disabled={true}
                      >
                        <svg
                          className="aaa-change-icon disabled-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M11.0599 2.33973C11.3056 2.58546 11.4573 2.90766 11.4917 3.25039H8.50673C8.54117 2.90766 8.69283 2.58546 8.93856 2.33973C9.21986 2.05843 9.60139 1.90039 9.99922 1.90039C10.397 1.90039 10.7786 2.05843 11.0599 2.33973ZM7.94861 1.34978C7.44021 1.85818 7.14008 2.5359 7.1031 3.25039H1.74922C1.56357 3.25039 1.38552 3.32414 1.25424 3.45542C1.12297 3.58669 1.04922 3.76474 1.04922 3.95039C1.04922 4.13604 1.12297 4.31409 1.25424 4.44537C1.38552 4.57664 1.56357 4.65039 1.74922 4.65039H2.77494L4.07301 15.896C4.17007 16.7369 4.57287 17.5127 5.20477 18.0759C5.83666 18.6391 6.65356 18.9503 7.50001 18.9504H12.4984C13.3449 18.9503 14.1618 18.6391 14.7937 18.0759C15.4256 17.5127 15.8284 16.7369 15.9254 15.896L17.2235 4.65039H18.2492C18.4349 4.65039 18.6129 4.57664 18.7442 4.44537C18.8755 4.31409 18.9492 4.13604 18.9492 3.95039C18.9492 3.76474 18.8755 3.58669 18.7442 3.45542C18.6129 3.32414 18.4349 3.25039 18.2492 3.25039H12.8953C12.8584 2.5359 12.5582 1.85818 12.0498 1.34978C11.506 0.805925 10.7683 0.500391 9.99922 0.500391C9.23009 0.500391 8.49246 0.805925 7.94861 1.34978ZM6.13615 17.0311C5.76064 16.6966 5.52118 16.2358 5.46333 15.7362C5.46333 15.7362 5.46333 15.7362 5.46332 15.7361L4.18462 4.65039H15.8138L14.5351 15.7361C14.4773 16.2357 14.2378 16.6966 13.8623 17.0311C13.4868 17.3657 13.0014 17.5505 12.4984 17.5504H7.50002C6.99708 17.5505 6.51168 17.3657 6.13615 17.0311ZM8.84419 7.30542C8.71292 7.17414 8.53487 7.10039 8.34922 7.10039C8.16357 7.10039 7.98552 7.17414 7.85424 7.30542C7.72297 7.43669 7.64922 7.61474 7.64922 7.80039V14.4004C7.64922 14.586 7.72297 14.7641 7.85424 14.8954C7.98552 15.0266 8.16357 15.1004 8.34922 15.1004C8.53487 15.1004 8.71292 15.0266 8.84419 14.8954C8.97547 14.7641 9.04922 14.586 9.04922 14.4004V7.80039C9.04922 7.61474 8.97547 7.43669 8.84419 7.30542ZM12.3492 7.80039C12.3492 7.61474 12.2755 7.43669 12.1442 7.30542C12.0129 7.17414 11.8349 7.10039 11.6492 7.10039C11.4636 7.10039 11.2855 7.17414 11.1542 7.30542C11.023 7.43669 10.9492 7.61474 10.9492 7.80039V14.4004C10.9492 14.586 11.023 14.7641 11.1542 14.8954C11.2855 15.0266 11.4636 15.1004 11.6492 15.1004C11.8349 15.1004 12.0129 15.0266 12.1442 14.8954C12.2755 14.7641 12.3492 14.586 12.3492 14.4004V7.80039Z"
                            fill="#1D4ED8"
                            stroke="#1D4ED8"
                            strokeWidth="0.3"
                          />
                        </svg>
                      </button>
                      <button
                        className="edit-icon aaa-change-icon disabled-icon"
                        aria-label={`${(type.name)} edit`}
                        onClick={() => notEditable(type)}
                        tabIndex="-1"
                        disabled={true}
                      >
                        <svg
                          className="aaa-change-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="18"
                          viewBox="0 0 16 18"
                          fill="none"
                        >
                          <path
                            d="M4.65122 14.1491H0.817969V10.3143L10.5199 0.642481L10.52 0.642316C10.8375 0.324878 11.2595 0.15 11.7092 0.15C12.1589 0.15 12.5809 0.324838 12.8993 0.643233L14.3532 2.09707C14.6715 2.41546 14.8464 2.83748 14.8464 3.28717C14.8464 3.73685 14.6715 4.15887 14.3532 4.47727L4.65122 14.1491ZM11.8152 1.7272L11.7093 1.62143L11.6033 1.7271L10.1467 3.1791L10.0403 3.2852L10.1466 3.39143L11.6004 4.84435L11.7063 4.95015L11.8123 4.84452L13.2698 3.39252L13.3764 3.28638L13.27 3.18012L11.8152 1.7272ZM2.3513 12.4657V12.6157H2.5013H3.95605H4.01805L4.06195 12.572L10.5144 6.13973L10.6208 6.03367L10.5145 5.92743L9.0607 4.4736L8.9548 4.3677L8.84873 4.47343L2.3954 10.9066L2.3513 10.9506V11.0128V12.4657ZM0.817969 16.2824H15.1846V17.8157H0.817969V16.2824Z"
                            fill="#1D4ED8"
                            stroke="#F1F5FF"
                            strokeWidth="0.3"
                          />
                        </svg>
                      </button>
                    </div>
                  )}
                </div>
              );
            }
          })}
        </div>
        <div className="flex justify-end mar-top20">
          <button className="blue-btn active new-form-btn-errorType" onClick={newForm}>
            New
          </button>
        </div>
      </div>
      <div className="right-topology">
        <div className="wrap-input-text-group mar-bot20">
          <label htmlFor="error-category-dropdown">Error Category</label>
          <div className="global-dropdown-block flex-center">
            <div className="global-dropdown-select">
              <Select
                classNamePrefix="cw"
                className="global-dropdown-select focus-input"
                value={errorCategories.filter(function (option) {
                  return option.value.id === selectedErrorCategory.id;
                })}
                isDisabled={formDisabled}
                placeholder="Select error category"
                aria-label="Error Category"
                options={errorCategories}
                onChange={(e) => handleErrorCategoryChange(e)}
                id="error-category-dropdown"
              />
            </div>
          </div>
        </div>
        <div className="wrap-input-text-group mar-bot20">
          <label htmlFor="error-type-name">Name </label>
          <div className="input-text-group flex">
            <input
              type="text"
              className={
                formDisabled
                  ? "form-control-sm input-text-disable"
                  : "form-control-sm"
              }
              value={newErrorTypeName}
              onChange={(e) => setNewErrorTypeName(e.target.value)}
              placeholder="Error Type"
              id="error-type-name"
              disabled={formDisabled}
            />
          </div>
        </div>
        <div className="wrap-input-text-group mar-bot20">
          <label htmlFor="error-type-id">ID </label>
          <div className="input-text-group flex">
            <input
              type="text"
              className={
                formDisabled
                  ? "form-control-sm input-text-disable"
                  : "form-control-sm"
              }
              value={newErrorTypeId}
              onChange={(e) => setNewErrorTypeId(e.target.value)}
              placeholder="Error Type ID(Dynamic, 1-9999)"
              id="error-type-id"
              disabled={formDisabled}
            />
          </div>
        </div>
        <div className="wrap-input-text-group mar-bot20 max-680">
          <label htmlFor="error-type-description" className="flex show-flex justify-center">Description <span>Optional</span></label>
          <div className="input-text-group flex">
            <textarea
              className={
                formDisabled
                  ? "textarea max-680 input-text-disable"
                  : "textarea max-680"
              }
              placeholder="255 characters left"
              value={newErrorTypeDescription}
              onChange={(e) => setNewErrorTypeDescription(e.target.value)}
              id="error-type-description"
              disabled={formDisabled}
            ></textarea>
          </div>
        </div>
        <div className="flex two-col justify-end mar-top30 max-680">
          <button
            className={formDisabled ? "blue-btn" : "blue-btn"}
            disabled={formDisabled}
            onClick={clearFields}
          >
            Cancel
          </button>
          <button
            className={
              newErrorTypeName === "" ||
              newErrorTypeId === "" ||
              selectedErrorCategory.id === undefined ||
              formDisabled
                ? "blue-btn active"
                : "blue-btn active"
            }
            disabled={
              newErrorTypeName === "" ||
              newErrorTypeId === "" ||
              selectedErrorCategory.id === undefined ||
              formDisabled
            }
            onClick={createUpdateErrorType}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
